import PropTypes from 'prop-types';
import { Grid } from '@ui-propulsion/react-components';
import { useState, useEffect } from 'react';
import BlogPostPreviewCard from '../blogPostPreviewCard/blogPostPreviewCard';
import styles from './moreArticlesAndResources.module.scss';
import Spinner from '../spinner/spinner';

export default function MoreArticlesAndResources({
  headline = 'More Articles And Resources',
  relatedArticles = [],
  product = null,
}) {
  const [articles, setArticles] = useState(relatedArticles);
  const [isLoading, setLoading] = useState(false);
  useEffect(() => {
    if (articles.length === 0 && product) {
      setLoading(true);
      fetch('/api/more-articles', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          product,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setArticles(
            data.map((post) => ({
              title: post.subTitle.label,
              url: post.subTitle.link,
              thumbnail: post.image,
              product: post.category.label,
            }))
          );
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [product, articles.length]);

  return (
    <section className="moreArticles">
      <h2 className={styles.headline}>{headline}</h2>
      {articles && (
        <Grid container>
          {articles?.map((post, ci) => (
            <Grid item key={`key-${ci}`.toString()} xs={6} md={3} lg={3}>
              <div className={styles.blogPostcardSingle}>
                <BlogPostPreviewCard
                  post={post}
                  mode={2}
                  previewCardClassName={`${styles.previewCardsummary}`}
                />
              </div>
            </Grid>
          ))}
        </Grid>
      )}
      {isLoading && (
        <div className={styles.spinnerWrapper}>
          <Spinner showSpinner={isLoading} />
        </div>
      )}
    </section>
  );
}

MoreArticlesAndResources.propTypes = {
  headline: PropTypes.string,
  relatedArticles: PropTypes.array,
  product: PropTypes.string,
};
